import { jsx as l } from "react/jsx-runtime";
import { c as n } from "../../index-C3-ZVs5E.js";
import { InputLabelWrapper as p } from "../input-label-wrapper/InputLabelWrapper.component.js";
import { Select as b } from "../select/Select.component.js";
import { useCallback as i } from "react";
import '../../assets/LabeledSelect.css';const f = "_label_1u8z6_2", u = {
  label: f
};
function N({
  id: r,
  labelText: o,
  error: t,
  labelClassName: a,
  containerClassName: m,
  ...e
}) {
  const s = i(
    (c) => /* @__PURE__ */ l(b, { ...c, ...e }),
    [e]
  );
  return /* @__PURE__ */ l(
    p,
    {
      labelText: o,
      id: r,
      className: n(u.label, a),
      containerClassName: m,
      error: t,
      children: s
    }
  );
}
export {
  N as LabeledSelect
};
